var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.4545L6.22102 0.865168C6.41617 0.344763 6.91366 0 7.46945 0H40.5305C41.0863 0 41.5838 0.344763 41.779 0.865168L48 17.4545V47C48 47.5523 47.5523 48 47 48H0.999999C0.447714 48 0 47.5523 0 47V17.4545ZM7.696 12.1212L10.2415 5.33333H37.7585L40.304 12.1212H7.696ZM34.3273 31.5271C34.99 32.4108 34.8109 33.6644 33.9273 34.3271L26.8 39.6726C25.1408 40.9171 22.8593 40.9171 21.2 39.6726L14.0727 34.3271C13.1891 33.6644 13.01 32.4108 13.6727 31.5271C14.3355 30.6435 15.5891 30.4644 16.4727 31.1271L21.9945 35.2685V21.8181C21.9945 20.7136 22.8899 19.8181 23.9945 19.8181C25.0991 19.8181 25.9945 20.7136 25.9945 21.8181V35.2768L31.5273 31.1271C32.4109 30.4644 33.6645 30.6435 34.3273 31.5271Z",
    fill: "#AFB7BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive-icon.fa5a8917d4023a0b8ea4d5adf99f35ab.svg";
export { ForwardRef as ReactComponent };